import { apiGet, apiPost, apiUpdate } from "../http";
export default {
  async getCategoriesAPI() {
    return await apiGet("api/categories");
  },
  async getCategoryAPI(id) {
    return await apiGet("api/category/" + id);
  },
  async putCategoryConfAPI(data) {
    return await apiUpdate("api/category/" + data.id, data.data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },
  async postNewSubCategoryAPI(data) {
    return await apiPost("api/categories/" + data.id, data.data);
  },
  async postNewRootCategoryAPI(data) {
    return await apiPost("api/categories/", data);
  },
  async getDropdownsAPI() {
    return await apiGet(
      "api/products/categories?categories=accents," +
        "closure%20type,condition,country,defect,description,features,garment%20care," +
        "gender,occassion,pattern,season,theme,material"
    );
  },
  async getCurrenciesAPI() {
    return await apiGet("api/products/categories?categories=currency");
  },
};
